import Vue from 'vue'
import 'regenerator-runtime/runtime.js' // Required for async functions

import { setContentHeight } from '../utils/helpers'
import { cart } from '../mixins/cart.js'
import { headerDropdowns } from '../mixins/headerDropdowns.js'
import HeaderSearch from '../components/header-search.js'

// Uncomment this to suppress Vue warnings in development mode
// Vue.config.silent = true;

export const app = new Vue({
  el: '#app',

  delimiters: ['${', '}'],

  components: {
    HeaderSearch
  },

  mixins: [
    cart,
    headerDropdowns
  ],

  data: {
    isAccountLinksShown: false,
    isLoginDrawerShown: false,
    isRegisterDrawerShown: false
  },

  computed: {

    welcomeDwLimit () {
      return window.theme_settings?.welcomedw_sku_limit_per_customer || 0
    },

    customerTags () {
      return window.customer_tags || ''
    },

    purchasedWelcomeDwQuantities () {
      if (!this.customerTags) return {}

      const quantities = {}
      const tags = this.customerTags.split(',')

      tags.forEach(tag => {
        const trimmedTag = tag.trim()
        if (trimmedTag.startsWith('welcome-purchase-')) {
          const match = trimmedTag.match(/welcome-purchase-.+-(.+?):(\d+)$/)
          if (match) {
            const sku = match[1]
            const qty = parseInt(match[2]) || 0
            quantities[sku] = (quantities[sku] || 0) + qty
          }
        }
      })

      return quantities
    }
  },

  mounted () {
    // Hide content until header has loaded
    document.querySelector('body').classList.remove('hidden')

    // Fix for iOS Safari 100vh issue
    // Set timeout to fix data racing issue with splide.js
    setTimeout(function () {
      setContentHeight()
    }, 1000)
    window.addEventListener('resize', () => setContentHeight())
  },

  methods: {
    showAccountLinks () {
      this.isAccountLinksShown = true
    },

    hideAccountLinks () {
      this.isAccountLinksShown = false
    },

    toggleLoginDrawer () {
      this.isLoginDrawerShown = !this.isLoginDrawerShown
    },

    toggleRegisterDrawer () {
      this.isRegisterDrawerShown = !this.isRegisterDrawerShown
    },

    isWelcomeDwLimitExceeded (item) {
      if (!item.properties?._is_welcome_product || !this.welcomeDwLimit) return false

      const currentSku = item.sku
      const rawPurchasedQuantity = this.purchasedWelcomeDwQuantities[currentSku] || 0

      const currentCartQuantity = this.cart?.items
        ?.filter(cartItem => cartItem.sku === currentSku)
        ?.reduce((total, cartItem) => total + cartItem.quantity, 0) || 0

      const bottlesPerCaseTag = item.tags?.find(tag => tag.toLowerCase().includes('bottles_per_case|'))
      const bottlesPerCase = bottlesPerCaseTag ? parseInt(bottlesPerCaseTag.split('|').pop()) : null

      const purchasedStacks = bottlesPerCase ? Math.ceil(rawPurchasedQuantity / bottlesPerCase) : rawPurchasedQuantity
      const currentStacks = bottlesPerCase ? Math.ceil(currentCartQuantity / bottlesPerCase) : currentCartQuantity
      const addingStacks = bottlesPerCase ? Math.ceil(1 / bottlesPerCase) : 1

      const totalStacks = purchasedStacks + currentStacks + addingStacks

      return totalStacks > this.welcomeDwLimit
    }
  }
})
